import { llmProviderForModel } from "../../../shared/llmModels";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { cn } from "../../lib/utils";

type ModelOption = { value: string; label: string };

type LlmModelSelectProps = {
  value: string;
  onChange: (model: string, provider: "openai" | "anthropic") => void;
  openAiModels: readonly ModelOption[];
  anthropicModels: readonly ModelOption[];
  className?: string;
  title?: string;
  "aria-label"?: string;
  disabled?: boolean;
};

export function LlmModelSelect({
  value,
  onChange,
  openAiModels,
  anthropicModels,
  className,
  title = "Model",
  "aria-label": ariaLabel = "Model",
  disabled = false,
}: LlmModelSelectProps) {
  const selectedLabel = [...openAiModels, ...anthropicModels].find(
    (option) => option.value === value
  )?.label;
  return (
    <Select
      value={value}
      disabled={disabled}
      onValueChange={(nextValue) => {
        onChange(nextValue, llmProviderForModel(nextValue));
      }}
    >
      <SelectTrigger
        className={cn(
          "h-8 shrink-0 border-input bg-background px-2.5 text-[0.78rem] text-foreground shadow-xs hover:bg-muted/40",
          className ?? "w-auto max-w-42"
        )}
        title={selectedLabel ? `${title}: ${selectedLabel}` : title}
        aria-label={ariaLabel}
        size="sm"
      >
        <SelectValue placeholder="Select model" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>OpenAI</SelectLabel>
          {openAiModels.map((m) => (
            <SelectItem key={m.value} value={m.value}>
              {m.label}
            </SelectItem>
          ))}
        </SelectGroup>
        <SelectGroup>
          <SelectLabel>Anthropic</SelectLabel>
          {anthropicModels.map((m) => (
            <SelectItem key={m.value} value={m.value}>
              {m.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
